export default "__VITE_ASSET__46a17056__"